import React, { useEffect } from 'react';

import { useMoreActionsMenuActions } from '@confluence/content-types-utils';

export const WithMoreActionsMenuOpen = ({ children }: { children: React.ReactNode }) => {
	const { setIsMenuOpen, setIsCloseMenuDisabled } = useMoreActionsMenuActions();
	useEffect(() => {
		void setIsCloseMenuDisabled(true);
		void setIsMenuOpen(true);

		return () => {
			void setIsCloseMenuDisabled(false);
			void setIsMenuOpen(false);
		};
	}, [setIsMenuOpen, setIsCloseMenuDisabled]);
	return <>{children}</>;
};
